import { state } from 'cerebral/tags'

const rules = {
  endsWith(value, arg, get) {
    const index = value.lastIndexOf(arg)
    if (index !== -1) {
      return value.substr(index, value.length - 1) === arg
    }
    return false
  },
  numeric(value, arg, get) {
    if (value.length > 0) {
      const unit = get(state`basket.unit`)
      if (unit === 'px') {
        return /^(?:[-+]?(?:0|[1-9]\d*))$/.test(value)
      }
      return /^[-+]?(?:\d*[.])?\d+$/.test(value)
    }

    return true
  },
  maxValue(value, arg, get) {
    if (parseFloat(value) > parseFloat(arg)) {
      return false
    }
    return true
  },
  preventBlanksBefore(value, arg, get) {
    if (value.indexOf(' ') === 0) {
      return false
    }
    return true
  }
}

export default rules



// WEBPACK FOOTER //
// ./src/utils/rules.js